module.exports = __webpack_public_path__ + "platform.png?0711f9c75d61140c2b5b9926b5395e5f";


//////////////////
// WEBPACK FOOTER
// ./static/assets/platform.png
// module id = 55
// module chunks = 0